import { app } from "./app";
import { GroupDetailComponent } from "./app/features/people/components/groups/group-detail.component";
import { GuestsPage } from "./app/features/events/pages/guests/guests.page";
import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import { AccessControlPage } from "./app/features/events/pages/access-control/access-control.page";
import { BeeEditorComponent } from "./app/shared/components/bee-editor/bee-editor.component";
import { AclDialogComponent } from "./app/shared/components/acl-dialog/acl-dialog.component";
import { LanguagesListPage } from "./app/features/common/pages/languages/languages-list.page";
import { LanguagesEditPage } from "./app/features/common/pages/languages/languages-edit.page";
import { IdentificationTypesListPage } from "./app/features/common/pages/identification-types/identification-types-list.page";
import { IdentificationTypesEditPage } from "./app/features/common/pages/identification-types/identification-types-edit.page";
import { LogService } from "./app/core/services/log.service";
import { AuthRegisterAuthCodeComponent } from "./app/features/auth/pages/register-auth-code/auth-register-auth-code.component";
import { AuthOtpInputComponent } from "./app/features/auth/components/otp-input/auth-otp-input.component";
import { AuthLoginComponent } from "./app/features/auth/pages/login/auth-login.component";
import { AuthResetPasswordComponent } from "./app/features/auth/pages/reset-password/auth-reset-password.component";
import { OAuthLoadingComponent } from "./app/features/auth/pages/oauth-loading/oauth-loading.component";

app
    .directive(
        'groupDetail', 
        downgradeComponent({component: GroupDetailComponent}) as angular.IDirectiveFactory
    )
    .directive(
        'eventGuestsPage', 
        downgradeComponent({component: GuestsPage}) as angular.IDirectiveFactory
    )
    .directive(
        'eventAccessControlPage', 
        downgradeComponent({component: AccessControlPage}) as angular.IDirectiveFactory
    )
    .directive(
        'aclDialog',
        downgradeComponent({ component: AclDialogComponent }) as angular.IDirectiveFactory
    )
    .directive(
        'beeEditor', 
        downgradeComponent({component: BeeEditorComponent}) as angular.IDirectiveFactory
    )
    .directive(
        'languagesListPage',
        downgradeComponent({ component: LanguagesListPage }) as angular.IDirectiveFactory
    )
    .directive(
        'languagesEditPage',
        downgradeComponent({ component: LanguagesEditPage }) as angular.IDirectiveFactory
    )
    .directive(
        'identificationTypesListPage',
        downgradeComponent({ component: IdentificationTypesListPage }) as angular.IDirectiveFactory
    )
    .directive(
        'identificationTypesEditPage',
        downgradeComponent({ component: IdentificationTypesEditPage }) as angular.IDirectiveFactory
    )
    .directive(
        'authRegisterAuthCode',
        downgradeComponent({ component: AuthRegisterAuthCodeComponent }) as angular.IDirectiveFactory
    )
    .directive(
        'authOtpInput',
        downgradeComponent({ component: AuthOtpInputComponent, inputs: ['value'], outputs: ['valueChange'] }) as angular.IDirectiveFactory
    )
    .directive(
        'authLogin',
        downgradeComponent({ component: AuthLoginComponent }) as angular.IDirectiveFactory
    )
    .directive(
        'authResetPassword',
        downgradeComponent({ component: AuthResetPasswordComponent }) as angular.IDirectiveFactory
    )
    .directive(
        'authOauthLoading',
        downgradeComponent({ component: OAuthLoadingComponent }) as angular.IDirectiveFactory
    )
    .factory(
        'logService', downgradeInjectable(LogService));
